function TabCard({ description, title, icon, onClick, id, active, img, color }) {
  const handleClick = () => {
    if (onClick) onClick();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') handleClick();
  };

  return (
    <div
      className={`tabCard ${active ? 'tabCard-active' : ''}`}
      role="tab"
      // aria-selected={active}
      // tabIndex="0"
      aria-labelledby={`${id}-title`}
      aria-describedby={`${id}-description`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <div className="tabCard-image-cotainer">
        <img className="tabCard-image" loading="lazy" width="100%" height="100%" src={img} alt="Icono lapiz y papel" />
      </div>

      <div className="cardTab-divider-container">
        <div className="cardTab-divider" style={{ background: color }}></div>
      </div>

      <div className="cardTab-body">
        <div dangerouslySetInnerHTML={{ __html: parseText('rutasServicios.icons')[id] }} />
        <p id={`${id}-description`} className="cardTab-description" dangerouslySetInnerHTML={{ __html: title }}></p>
      </div>
    </div>
  );
}

export default TabCard;
